<script>
import Persona from '../pages/Persona/PersonaPage.vue'
import Rol from '../pages/Rol/RolPage.vue'
import Departamento from '../pages/Departamento/DepartamentoPage.vue'
import Fuerza from '../pages/Fuerza/FuerzaPage.vue'
import Especialidad from '../pages/Especialidad/EspecialidadPage.vue'
import Cargo from '../pages/Cargo/CargoPage.vue'
import Profesion from '../pages/Profesion/ProfesionPage.vue'
import Escalafon from '../pages/Escalafon/EscalafonPage.vue'
import Grado from '../pages/Grado/GradoPage.vue'
import Familiar from '../pages/Familiar/FamiliarPage.vue'
import TipoFamiliar from '../pages/TipoFamiliar/TipoFamiliarPage.vue'
import TipoCapacitacion from '../pages/TipoCapacitacion/TipoCapacitacionPage.vue'
import CapacitacionProfesional from '../pages/CapacitacionProfesional/CapacitacionProfesionalPage.vue'
import Reparticion from '../pages/Reparticion/ReparticionPage.vue'
import Profile from '../pages/Profile/ProfilePage.vue'
import Login from '../pages/Login/LoginPage.vue'
import Sexo from '../pages/Sexo/SexoPage.vue'
import GrupoSanguineo from '../pages/GrupoSanguineo/GrupoSanguineoPage.vue'
import EstadoCivil from '../pages/EstadoCivil/EstadoCivilPage.vue'
import Arma from '../pages/Arma/ArmaPage.vue'
import TipoArmamento from '../pages/TipoArmamento/TipoArmamentoPage.vue'
import ArmamentoDotacion from '../pages/ArmamentoDotacion/ArmamentoDotacionPage.vue'
import Ascenso from '../pages/Ascenso/AscensoPage.vue'
import Destino from '../pages/Destino/DestinoPage.vue'


import TipoMerito from '../pages/TipoMerito/TipoMeritoPage.vue'

import Merito from '../pages/Merito/MeritoPage.vue'

import EstadoDocumento from '../pages/EstadoDocumento/EstadoDocumentoPage.vue'
import ConceptoSP from '../pages/ConceptoSP/ConceptoSPPage.vue'
import SituacionConcepto from '../pages/SituacionConcepto/SituacionConceptoPage.vue'
import ServicioPersonal from '../pages/ServicioPersonal/ServicioPersonalPage.vue'
import Demerito from '../pages/Demerito/DemeritoPage.vue'
import OrdenDeMerito from '../pages/OrdenDeMerito/OrdenDeMeritoPage.vue'
import FojaConcepto from '../pages/FojaConcepto/FojaConceptoPage.vue'
import MenuSP from '../pages/ServicioPersonal/MenuPage.vue'
import EstadoViatico from '../pages/EstadoViatico/EstadoViaticoPage.vue'
import TipoViatico from '../pages/TipoViatico/TipoViaticoPage.vue'
import Lugar from '../pages/Lugar/LugarPage.vue'
import CategoriaViatico from '../pages/CategoriaViatico/CategoriaViaticoPage.vue'
import TipoPasaje from '../pages/TipoPasaje/TipoPasajePage.vue'
import Pasaje from '../pages/Pasaje/PasajePage.vue'
import FleteAlmacenamiento from '../pages/FleteAlmacenamiento/FleteAlmacenamientoPage.vue'
import PersonaViatico from '../pages/PersonaViatico/PersonaViaticoPage.vue'
import GenerarViatico from '../pages/GenerarViatico/GenerarViaticoPage.vue'
import Reporte from '../pages/Reporte/ReportePage.vue'
import ReporteSP from '../pages/ReporteSP/ReporteSPPage.vue'

import Externo from '../pages/Externo/ExternoPage.vue'
import CapProf from '../pages/CapProf/CapProfPage.vue'

import CarDest from '../pages/CarDest/CarDestPage.vue'
import SeccionCargosDestinos from '../pages/SeccionCargosDestinos/SeccionCargosDestinosPage.vue'
import SeccionProcesamiento from '../pages/SeccionProcesamiento/SeccionProcesamientoPage.vue'
import SeccionDiciplina from '../pages/SeccionDiciplina/SeccionDiciplinaPage.vue'

import ControlPersonal from '../pages/ControlPersonal/ControlPersonalPage.vue'
import Modulos from '../pages/Modulos/ModulosPage.vue'
import BienestarSocial from '../pages/BienestarSocial/BienestarSocialPage.vue'
import Ascensos from '../pages/Ascensos/AscensosPage.vue'
import Dashboard from '../pages/Dashboard/Dashboard.vue'
import Vacacion from '../pages/Vacacion/VacacionPage.vue'
import CargaMasiva from '../pages/CargaMasiva/CargaMasivaPage.vue'
import ReporteCargaMasiva from '../pages/ReporteCargaMasiva/ReporteCargaMasivaPage.vue'
import PersonaViaticoInd from '../pages/PersonaViaticoInd/PersonaViaticoIndPage.vue'

const routes = [
  { path: '/Persona', component: Persona },
  { path: '/Rol', component: Rol },
  { path: '/Departamento', component: Departamento },
  { path: '/Ascenso', component: Ascenso },
  { path: '/Destino', component: Destino },
  { path: '/Fuerza', component: Fuerza },
  { path: '/Especialidad', component: Especialidad },
  { path: '/Cargo', component: Cargo },
  { path: '/Escalafon', component: Escalafon },
  { path: '/Grado', component: Grado },
  { path: '/Reparticion', component: Reparticion },
  { path: '/Profesion', component: Profesion },
  { path: '/Profile', component: Profile },
  { path: '/', component: Login },
  { path: '/Sexo', component: Sexo },
  { path: '/Familiar', component: Familiar },
  { path: '/TipoFamiliar', component: TipoFamiliar },
  { path: '/TipoCapacitacion', component: TipoCapacitacion },
  { path: '/CapacitacionProfesional', component: CapacitacionProfesional },
  { path: '/GrupoSanguineo', component: GrupoSanguineo },
  { path: '/EstadoCivil', component: EstadoCivil },
  { path: '/Arma', component: Arma },
  { path: '/TipoArmamento', component: TipoArmamento },
  { path: '/ArmamentoDotacion', component: ArmamentoDotacion },
  { path: '/TipoMerito', component: TipoMerito },
  { path: '/Merito', component: Merito },
  { path: '/ControlPersonal', component: ControlPersonal },
  { path: '/Modulos', component: Modulos },
  { path: '/BienestarSocial', component: BienestarSocial },
  { path: '/Ascensos', component: Ascensos },

  { path: '/EstadoDocumento', component: EstadoDocumento },
  { path: '/ConceptoSP', component: ConceptoSP },
  { path: '/SituacionConcepto', component: SituacionConcepto },
  { path: '/ServicioPersonal', component: ServicioPersonal },
  { path: '/MenuSP', component: MenuSP },
  { path: '/MenuSPPermanentes', component: MenuSP },
  { path: '/MenuSPEventual', component: MenuSP },
  { path: '/MenuSPAltas', component: MenuSP },
  { path: '/MenuSPAsignacionesFamiliares', component: MenuSP },
  { path: '/MenuSPLetras', component: MenuSP },
  { path: '/MenuSPConclusiones', component: MenuSP },
  { path: '/MenuSPBajas', component: MenuSP },
  { path: '/MenuSPAscensos', component: MenuSP },
  { path: '/MenuSPDestino', component: MenuSP },
  { path: '/MenuSPVarios', component: MenuSP },
  { path: '/MenuReporteSP', component: ReporteSP },
  { path: '/Demerito', component: Demerito },
  { path: '/OrdenDeMerito', component: OrdenDeMerito },
  { path: '/FojaConcepto', component: FojaConcepto },
  { path: '/EstadoViatico', component: EstadoViatico },
  { path: '/TipoViatico', component: TipoViatico },
  { path: '/Lugar', component: Lugar },
  { path: '/CategoriaViatico', component: CategoriaViatico },
  { path: '/Pasaje', component: Pasaje },
  { path: '/TipoPasaje', component: TipoPasaje },
  { path: '/FleteAlmacenamiento', component: FleteAlmacenamiento },
  { path: '/PersonaViatico', component: PersonaViatico },
  { path: '/GenerarViatico', component: GenerarViatico },
  { path: '/Reporte', component: Reporte },

  { path: '/Externo', component: Externo },
  { path: '/CapProf', component: CapProf },
  { path: '/CarDest', component: CarDest },

  { path: '/SeccionCargosDestinos', component: SeccionCargosDestinos },
  { path: '/SeccionProcesamiento', component: SeccionProcesamiento },
  { path: '/SeccionDiciplina', component: SeccionDiciplina },
  { path: '/Dashboard', component: Dashboard },
  { path: '/Vacacion', component: Vacacion },
  { path: '/CargaMasiva', component: CargaMasiva },
  { path: '/ReporteCargaMasiva', component: ReporteCargaMasiva },
  { path: '/PersonaViaticoInd', component: PersonaViaticoInd }


]

export default routes;
</script>
